export enum PropertyTypeCode{
    EMPTY,  
    Boolean,
    Char, 
    Number, 
    Decimal,
    DateTime, 
    String, 
    Gender,
    Title, 
    Country, 
    Region,
    PostCode,
    DateOfBirth,
    DateOfBirthNoYear,
    Option
}